module.exports = __webpack_public_path__ + "img/Confirmation.f41fffe5.svg";